import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private readonly TOKEN_KEY = 'authToken';
  private tokenSubject = new BehaviorSubject<string | null>(
    this.getStoredToken()
  );

  constructor() {
    // Inicializa el token desde localStorage al iniciar
    if (typeof window !== 'undefined') {
      this.tokenSubject.next(this.getStoredToken());
    }
  }

  private getStoredToken(): string | null {
    return typeof window !== 'undefined'
      ? localStorage.getItem(this.TOKEN_KEY)
      : null;
  }

  getToken(): string | null {
    return this.tokenSubject.value;
  }

  saveToken(token: string): void {
    if (typeof window !== 'undefined') {
      localStorage.setItem(this.TOKEN_KEY, token);
      this.tokenSubject.next(token);
    }
  }

  removeToken(): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(this.TOKEN_KEY);
      this.tokenSubject.next(null);
    }
  }
}
